import { Component, inject } from '@angular/core';
import { ModalRef, ModalModule, ButtonV2Module } from '@schenck/rotec-components';
import { TranslatePipe, TranslateDirective } from '@ngx-translate/core';

export interface ConfirmModal {
  title: string;
  text: string;
  name: string;
}

@Component({
  selector: 'delete-user-modal',
  templateUrl: './delete-user-modal.component.html',
  styleUrls: ['./delete-user-modal.component.less'],
  imports: [ModalModule, TranslatePipe, TranslateDirective, ButtonV2Module],
})
export class DeleteUserModelComponent {
  public modalRef = inject<ModalRef<ConfirmModal, true>>(ModalRef);

  public isClicked = false;

  cancel() {
    this.modalRef.close();
  }

  confirm() {
    this.isClicked = true;
    this.modalRef.emit(true);
  }
}
